/* Marti 2.0 — the Marmini & Co. chat concierge. Fully client-side.
   Synonym+fuzzy intent engine, conversation context, live calendar lookups,
   in-chat quote math, industry knowledge, big martini energy. */
(function () {
  var RATES = { pp: { bronze: 3, silver: 6, gold: 8, platinum: 12 }, tender: 50, tenderPer: 75, barback: 35, server: 35, cleanup: 60, mobar: 300, mobarAlone: 600, cartini: 150, cartiniAlone: 250, alabaster: 150 };
  var BOOK = '/pages/book-now', PRICING = '/pages/pricing', MENU = '/pages/drink-menu', GALLERY = '/pages/gallery', ABOUT = '/pages/about', SERVICES = '/pages/services', FAQS = '/pages/faqs';
  var PHONE = '(734) 516-1004', EMAIL = 'marminimobilebar@gmail.com';

  function fmt(n) { return '$' + n.toLocaleString('en-US'); }
  function link(href, label) { return '<a href="' + href + '">' + label + '</a>'; }
  var CALL = '📞 <a href="tel:+17345161004">' + PHONE + '</a>';

  /* ---------- text normalization ---------- */
  var SYNONYMS = {
    booze: 'alcohol', liquor: 'alcohol', spirits: 'alcohol', drinks: 'drink', beverage: 'drink', beverages: 'drink',
    cost: 'price', costs: 'price', pricing: 'price', prices: 'price', rate: 'price', rates: 'price', charge: 'price', fees: 'price', fee: 'price', quote: 'price', expensive: 'price', cheap: 'price',
    hire: 'book', reserve: 'book', booking: 'book', rent: 'rental', renting: 'rental',
    trailer: 'mobar', wagon: 'mobar',
    bartenders: 'bartender', barkeep: 'bartender', mixologist: 'bartender',
    gratuity: 'tip', tipping: 'tip', tips: 'tip',
    insured: 'insurance', coi: 'insurance', licensed: 'insurance', permit: 'insurance',
    mocktails: 'mocktail', zeroproof: 'mocktail',
    outside: 'outdoor', outdoors: 'outdoor', backyard: 'outdoor', inside: 'indoor', indoors: 'indoor',
    electricity: 'power', outlet: 'power', generator: 'power', plug: 'power',
    rain: 'weather', snow: 'weather', storm: 'weather', wind: 'weather',
    reschedule: 'cancellation', refund: 'cancellation', postpone: 'cancellation',
    deposit: 'payment', pay: 'payment', invoice: 'payment', venmo: 'payment', zelle: 'payment',
    kids: 'children', teens: 'children', teen: 'children', teenager: 'children', teenagers: 'children', minors: 'children', minor: 'children', underage: 'children', drinking_age: 'children',
    glasses: 'glassware',
    michigan: 'area', detroit: 'area', canton: 'area'
  };

  function normalize(str) {
    return str.toLowerCase()
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9\/\-\s$]/g, ' ')
      .split(/\s+/)
      .filter(Boolean)
      .map(function (w) {
        if (SYNONYMS[w]) return SYNONYMS[w];
        var sing = w.length > 3 && w.slice(-1) === 's' ? w.slice(0, -1) : w;
        return SYNONYMS[sing] || w;
      });
  }

  function fuzzyEq(a, b) {
    if (a === b) return true;
    if (a.length < 5 || b.length < 5 || Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length > b.length) i++;
      else if (b.length > a.length) j++;
      else { i++; j++; }
    }
    return edits + (a.length - i) + (b.length - j) <= 1;
  }

  /* ---------- knowledge base ---------- */
  var lastTopic = null;

  function estimate(guests, hours) {
    var g = guests || 100, h = hours || 4;
    var tenders = Math.max(1, Math.ceil(g / RATES.tenderPer));
    var drinks = g * RATES.pp.gold;
    var staff = tenders * RATES.tender * h;
    var total = drinks + staff + RATES.mobar;
    return 'Okay, ' + g + ' guests × ' + h + ' hours — lemme shake that up (Gold package + the Mobar, our usual combo)...<br><br>' +
      '🍹 Gold pkg (4 signatures) × ' + g + ' guests: <b>' + fmt(drinks) + '</b><br>' +
      '🍸 ' + tenders + ' bartender' + (tenders > 1 ? 's' : '') + ' × ' + h + ' hrs × $' + RATES.tender + ': <b>' + fmt(staff) + '</b><br>' +
      '🛻 The Mobar with package: <b>' + fmt(RATES.mobar) + '</b><br><br>' +
      '💛 Ballpark: <b>' + fmt(total) + '</b> — booze not included (you buy it, we hand you the exact list).<br><br>' +
      'Remix it on the ' + link(PRICING, 'pricing page') + ' or ' + link(BOOK, 'lock in your date') + ' 😤';
  }

  var KB = [
    /* ===== site & business ===== */
    { id: 'price', topic: 'price', k: ['price', '$', 'budget', 'afford', 'estimate'],
      chips: ['Drink packages', 'Bar rental prices', 'Do the math for me'],
      a: function () {
        return 'Full transparency — straight off the 2025 rate card 💅<br><br>🍹 <b>Per person:</b> Bronze $' + RATES.pp.bronze + ' · Silver $' + RATES.pp.silver + ' · Gold $' + RATES.pp.gold + ' · Platinum $' + RATES.pp.platinum + '<br>🍸 <b>Bartenders:</b> $' + RATES.tender + '/hr (1 per ' + RATES.tenderPer + ' guests)<br>🛻 <b>Bars:</b> Mobar +$' + RATES.mobar + ' · Cartini/Alabaster +$' + RATES.cartini + '<br><br>Say <i>"120 guests for 5 hours"</i> and I\'ll do the math right here 🧮 Or the ' + link(PRICING, 'pricing page') + ' itemizes it live.';
      } },
    { id: 'packages', topic: 'price', k: ['package', 'bronze', 'silver', 'gold', 'platinum', 'signature', 'tier'],
      chips: ['Do the math for me', 'Signature drink ideas', 'Book now'],
      a: function () {
        return 'Four drink packages, priced per person 🍹<br><br>🥉 <b>Bronze $' + RATES.pp.bronze + '</b> — pour service (beer/wine/champagne + cups & ice)<br>🥈 <b>Silver $' + RATES.pp.silver + '</b> — 2 signature drinks<br>🥇 <b>Gold $' + RATES.pp.gold + '</b> — 4 signatures (the crowd favorite)<br>💎 <b>Platinum $' + RATES.pp.platinum + '</b> — 6 signatures, full flex<br><br>All signature packages include cups, straws, stirrers, ingredients, mixers, garnishes & ice. ' + link(PRICING, 'Compare them here') + ' — click one and watch it build your estimate ✨';
      } },
    { id: 'bars', topic: 'bars', k: ['mobar', 'cartini', 'alabaster', 'horse', 'which bars', 'setups', 'bar options', 'the bars'],
      chips: ['Bar rental prices', 'Will it fit?', 'See the gallery'],
      a: function () {
        return 'The fleet! My three gorgeous coworkers 😍<br><br>🛻 <b>The "Mobar"</b> — rustic white horse trailer w/ sink & ice bin, +$' + RATES.mobar + ' with any package. THE showstopper.<br>🪵 <b>The "Cartini"</b> — satellite wood bar, +$' + RATES.cartini + '. Garden-party royalty.<br>⬜ <b>The "Alabaster"</b> — crisp white panels, +$' + RATES.alabaster + '. Ballroom elegant.<br><br>Watch them shape-shift through venues on the ' + link('/', 'homepage') + ' or stalk them in the ' + link(GALLERY, 'gallery') + ' 📸';
      } },
    { id: 'rental', topic: 'bars', k: ['rental', 'dry hire', 'bar only', 'without bartender', 'borrow'],
      chips: ['The bars', 'Book now', 'Whats included'],
      a: function () {
        return 'Just the pretty bar? Respect 🪵<br><br>Solo day rentals: <b>Mobar $' + RATES.mobarAlone + '/day</b> · <b>Cartini $' + RATES.cartiniAlone + '/day</b> — delivery, setup & pickup included within 20 miles of Canton. Add a drink package and the bar fee drops to $' + RATES.mobar + '/$' + RATES.cartini + '.<br><br>' + link(BOOK, 'Grab a date') + ' before your cousin does.';
      } },
    { id: 'staff', topic: 'staff', k: ['bartender', 'server', 'barback', 'bar back', 'cleanup', 'crew', 'how many bartender', 'venue has a bar', 'already has a bar', 'already have a bar', 'has its own bar', 'have our own bar'],
      chips: ['Do the math for me', 'Whats included', 'Book now'],
      a: function () {
        return 'The crew, by the hour 🍸<br><br>🍸 <b>Bartender $' + RATES.tender + '/hr</b> — 1 per ' + RATES.tenderPer + ' guests, every tool included<br>💪 <b>Bar back $' + RATES.barback + '/hr</b> — keeps big events flying<br>🤵 <b>Event server $' + RATES.server + '/hr</b> — table-side drink runs<br>🧹 <b>Cleanup $' + RATES.cleanup + '/hr</b> — we reset your venue like nothing happened<br><br>' + link(BOOK, 'Book the crew') + ' ✨';
      } },
    { id: 'drinks', topic: 'drinks', k: ['drink', 'cocktail', 'menu', 'margarita', 'mojito', 'mimosa', 'bloody mary', 'lemonade', 'espresso martini', 'serve', 'pour'],
      chips: ['Mocktails?', 'Signature drink ideas', 'Drink packages'],
      a: function () {
        return 'You\'re speaking my language 🤤 We pour:<br><br>🍸 Cocktails · 🍓 Mocktails · 🥂 Mimosa bars · 🍅 Bloody Mary bars · 🍋 Fresh-squeezed lemonade (spiked optional)<br><br>Every event gets a personalized signature menu + custom cups. The ' + link(MENU, 'drink menu page') + ' has videos that will make you thirsty — sorry in advance.';
      } },
    { id: 'mocktail', topic: 'drinks', k: ['mocktail', 'dry event', 'no alcohol', 'alcohol free', 'non alcoholic'],
      chips: ['Drink packages', 'Kids at events?', 'Book now'],
      a: function () {
        return 'Zero-proof, full flavor 🍓 Dry events are 100% our thing — mocktail menus for grad parties, showers, workplaces, sober celebrations. Same custom menu treatment, same pretty cups.<br><br>One reviewer hired us because we made "mocktails for the under-21 crowd AND amazing drinks for the adults." Both worlds, one bar 💛<br><br>' + link(BOOK, 'Plan a dry one') + ' — Bronze/Silver pricing usually fits best.';
      } },
    { id: 'alcohol-law', topic: 'alcohol', k: ['alcohol', 'byob', 'provide', 'buy the', 'sell', 'shopping list', 'leftover'],
      chips: ['How much do I buy?', 'Whats included', 'Pricing'],
      a: function () {
        return 'Michigan law: we can\'t sell you the alcohol — so you buy it, and honestly? You win 🏆<br><br>✅ We hand you an <b>exact shopping list</b> (no over-buying)<br>✅ We can arrange pickup from our partner store<br>✅ Leftover bottles stay yours<br>✅ We bring everything else — mixers, garnishes, ice, cups<br><br>Ballpark your quantities with the calculator on the ' + link(MENU, 'drink menu page') + ' 🧮';
      } },
    { id: 'quantity', topic: 'alcohol', k: ['how much alcohol', 'how many bottles', 'quantity', 'how much do i buy', 'cases', 'handles'],
      chips: ['Do the math for me', 'Drink packages', 'Book now'],
      a: function () {
        return 'The rule of thumb the whole industry uses: <b>2 drinks per guest the first hour, 1 per hour after</b> 🧮 From there it splits by crowd — beer-and-wine folks vs cocktail crowd.<br><br>Slide the numbers on our ' + link(MENU + '#drink-calculator', 'booze calculator') + ' for bottles-and-cases, and when you book we build your exact list (and can arrange the pickup). Nobody ends up with 4 sad extra handles of vodka on our watch.';
      } },
    { id: 'area', topic: 'area', k: ['area', 'travel', 'where', 'located', 'location', 'far', 'distance', 'novi', 'plymouth', 'livonia', 'ypsilanti', 'dearborn', 'wayne'],
      chips: ['Travel fees?', 'Book now', 'Contact us'],
      a: function () {
        return 'Home base: Canton, MI 🏠 We roll all over Metro Detroit & Wayne County — Plymouth, Livonia, Ann Arbor, Novi, Northville, Dearborn, Ypsi, Detroit proper, all of it.<br><br>Bar delivery/setup/pickup is <b>included within 20 miles of Canton</b>; farther out gets quoted transparently. The Mobar loves a road trip 🛻💨';
      } },
    { id: 'book', topic: 'book', k: ['book', 'get started', 'process', 'how does it work', 'steps', 'lock in'],
      chips: ['Check a date', 'Pricing', 'Whats included'],
      a: function () {
        return 'Easy as squeezing a lemon 🍋<br><br>1️⃣ ' + link(BOOK, 'The booking form') + ' — date, location, guests, vibe<br>2️⃣ Quick consult → custom quote + drink menu<br>3️⃣ You shop off our exact list<br>4️⃣ We roll up, pour all night, pack out 🎉<br><br>There\'s a live availability calendar on the booking page — tap an open date and it fills the form for you.';
      } },
    { id: 'availability', topic: 'book', k: ['available', 'availability', 'open', 'calendar', 'free on', 'date work'],
      chips: ['Book now', 'Pricing', 'Contact us'],
      a: function () {
        return 'Ask me with a date and I\'ll actually check! Try <i>"are you free October 10?"</i> 👀<br><br>Or browse the live per-bar calendar at the top of the ' + link(BOOK, 'booking page') + ' — tap an open date and it drops straight into the form.';
      } },
    { id: 'contact', topic: 'contact', k: ['contact', 'phone', 'call', 'text', 'email', 'human', 'person', 'mariah', 'owner', 'talk'],
      chips: ['Book now', 'Pricing', 'About the team'],
      a: function () {
        return 'Want a real human instead of a talking martini? Rude, but fair 😌<br><br>' + CALL + ' — call or text<br>📧 <a href="mailto:' + EMAIL + '">' + EMAIL + '</a><br><br>That\'s Mariah — owner, menu designer, and the reason everything looks this good.';
      } },
    { id: 'team', topic: 'about', k: ['team', 'who', 'sabrina', 'story', 'woman owned', 'about you', 'founded'],
      chips: ['The bars', 'Reviews', 'Book now'],
      a: function () {
        return 'Woman-owned crew out of Canton 💪<br><br>👑 <b>Mariah</b> — owner, bartender, menu designer, boss<br>🍸 <b>Sabrina</b> — assistant manager, fastest shaker in Metro Detroit<br>🍸 <b>Me, Marti</b> — resident martini, professional charmer<br><br>Flip our cards on the ' + link(ABOUT, 'about page') + ' (literally, they flip).';
      } },
    { id: 'reviews', topic: 'about', k: ['review', 'testimonial', 'rating', 'trust', 'experience', 'good'],
      chips: ['Book now', 'The bars', 'Gallery'],
      a: function () {
        return 'Five stars across the board ⭐⭐⭐⭐⭐ A few greatest hits:<br><br>"Over 300 people attended and every single person loved the drinks."<br>"She customized mocktails for the under-21 crowd... everyone loved her!"<br>"My cups were customized and they provided a menu — 10/10."<br><br>Receipts are all over the ' + link('/', 'homepage') + ' 💛';
      } },
    { id: 'gallery', topic: 'about', k: ['gallery', 'photos', 'pictures', 'instagram', 'social', 'follow'],
      chips: ['The bars', 'Book now', 'Reviews'],
      a: function () {
        return 'Stalk away 📸 The ' + link(GALLERY, 'gallery') + ' has the full portfolio, and we\'re @marminimobilebar on <a href="https://www.instagram.com/marminimobilebar" target="_blank" rel="noopener">Instagram</a> + <a href="https://www.facebook.com/marminimobilebar" target="_blank" rel="noopener">Facebook</a> for the daily pours.';
      } },
    { id: 'addons', topic: 'addons', k: ['addon', 'extras', 'custom cups', 'signage'],
      chips: ['Pricing', 'Book now', 'Drink menu'],
      a: function () {
        return 'The fun stuff on top 🎁 Custom menus & bar signage, personalized cups (a fan favorite — check the reviews), mocktail stations, extra crew, and event cleanup ($' + RATES.cleanup + '/hr).<br><br>Stack any of it on when you ' + link(BOOK, 'book') + '.';
      } },
    { id: 'events', topic: 'events', k: ['event', 'corporate', 'birthday', 'festival', 'gender reveal', 'engagement', 'anniversary', 'occasion', 'graduation'],
      chips: ['Wedding bar?', 'Pricing', 'Book now'],
      a: function () {
        return 'If it\'s a party, we pour at it 🎉 Weddings, birthdays, grads, engagements, showers, gender reveals, corporate gigs, festivals, block parties, sip & shops, campgrounds — one event had 300+ guests and every single one loved the drinks (that\'s a direct quote).<br><br>' + link(BOOK, 'Tell us about yours') + ' 💛';
      } },

    /* ===== industry brain ===== */
    { id: 'wedding', topic: 'events', k: ['wedding', 'reception', 'open bar', 'cash bar', 'toast', 'bride', 'groom'],
      chips: ['Signature drink ideas', 'Pricing', 'Check a date'],
      a: function () {
        return 'Weddings are our home turf 💍 The playbook that works:<br><br>🥂 Champagne pour for the toast (Bronze handles it)<br>🍸 2 "his & hers" signatures (Silver) or 4 (Gold — most couples land here)<br>🍋 A zero-proof signature so every guest gets a "fancy" drink<br><br>Pro tip: mobile bars in Michigan are <b>open bar by design</b> — you buy the alcohol, so there\'s no per-drink markup and no awkward cash bar. Guests drink free, you pay store prices. ' + link(BOOK, 'Lock your date') + ' — wedding season books fastest.';
      } },
    { id: 'tip', topic: 'industry', k: ['tip', 'tip jar', 'service charge', 'should we tip', 'do we tip', 'do i tip', 'tip the bartender', 'how much to tip'],
      chips: ['Pricing', 'Whats included', 'Book now'],
      a: function () {
        return 'The etiquette everyone asks about 💸 Industry standard for private-event bartending is <b>15–20% of the bar service</b> OR a tip jar on the bar — hosts usually pick one, not both. Some hosts pre-tip so the jar stays hidden (classy move for weddings).<br><br>Totally your call — tell us your preference when you book and we\'ll play it your way. No surprise service charges from us either way 🤝';
      } },
    { id: 'insurance', topic: 'industry', k: ['insurance', 'venue require', 'certificate'],
      chips: ['Contact us', 'Book now', 'Space needed?'],
      a: function () {
        return 'Smart question — most venues ask 📋 Requirements vary (general liability, sometimes liquor liability, a COI naming the venue).<br><br>Paperwork like this gets sorted during booking so your venue gets exactly what it needs — text Mariah at ' + CALL + ' with your venue\'s requirements and she\'ll square it with their coordinator directly. Smooth is the whole job 🤝';
      } },
    { id: 'children', topic: 'industry', k: ['children', 'card', '21', 'id check', 'children get a drink', 'serve children'],
      chips: ['Mocktails?', 'Book now', 'Reviews'],
      a: function () {
        return 'House rules, non-negotiable 🚫🍸 Nobody under 21 gets served alcohol — our bartenders check when in doubt, period.<br><br>The fun part: we make the under-21 crowd their own <b>signature mocktails</b> so they\'re not stuck with warm soda. One grad-party mom hired us exactly for that and left a glowing review. Kids feel fancy, parents relax 💛';
      } },
    { id: 'weather', topic: 'industry', k: ['weather', 'outdoor', 'plan b', 'backup', 'tent', 'cold', 'hot'],
      chips: ['Power needs?', 'Space needed?', 'Book now'],
      a: function () {
        return 'Michigan weather keeps everyone humble 🌦️ The playbook:<br><br>⛺ Outdoor events: a tent or covered spot for the bar is the classic Plan B<br>🛻 The Mobar is its own shelter — the serving window works rain or shine<br>🧊 Hot days: extra ice & coolers; cold days: warm-batch drinks exist and they slap<br><br>Tell us your venue layout when you book and we\'ll plan the fallback together — we\'ve poured through all four seasons, sometimes in one day. It\'s Michigan 😌';
      } },
    { id: 'power', topic: 'industry', k: ['power', 'hookup', 'water', 'need electricity'],
      chips: ['Space needed?', 'Outdoor events?', 'Book now'],
      a: function () {
        return 'Easier than you\'d think 🔌 Most setups run fine with zero hookups — coolers and ice do the heavy lifting. The Mobar has a sink & ice bin built in, and we can bring a <b>generator and extension cords</b> if your spot needs them (just ask when booking). Blenders or string lights? A standard outlet nearby is plenty.<br><br>No water line needed. We\'re self-sufficient like that 💅';
      } },
    { id: 'space', topic: 'industry', k: ['space', 'fit', 'size', 'dimensions', 'how big', 'driveway', 'gate', 'will it fit'],
      chips: ['Power needs?', 'The bars', 'Book now'],
      a: function () {
        return 'The Mobar needs a vehicle-accessible path and roughly a parking-space footprint plus serving room 🛻 — driveways, lawns with access, lots: all fair game.<br><br>The Cartini and Alabaster roll through regular doorways — living rooms, ballrooms, garages, wherever.<br><br>Send venue pics with your ' + link(BOOK, 'booking form') + ' and we\'ll confirm fit before you commit. We\'ve squeezed into some legendary spots.';
      } },
    { id: 'timing', topic: 'industry', k: ['setup', 'arrive', 'early', 'timeline', 'last call', 'breakdown', 'how long'],
      chips: ['How it works', 'Book now', 'Pricing'],
      a: function () {
        return 'The invisible-magic timeline 🪄 We arrive early to set up (before your guests — for weddings, before the ceremony so nothing disturbs the vows), pour through your service window, call last call ~15 min before close, then break down and vanish.<br><br>Setup and breakdown are <b>included</b> — your service hours are pure pouring time. Add the cleanup crew ($' + RATES.cleanup + '/hr) if you want the whole venue reset too 🧹';
      } },
    { id: 'payment', topic: 'industry', k: ['payment', 'when do i pay', 'hold my date', 'cash'],
      chips: ['Cancellation?', 'Pricing', 'Book now'],
      a: function () {
        return 'Money logistics get confirmed with your quote — Mariah walks you through holding your date, payment timing, and methods when she sends it (texts are fastest: ' + CALL + ').<br><br>What I can promise: the ' + link(PRICING, 'pricing page') + ' math IS the real rate card, and your final quote itemizes every line before you pay a cent. No gotchas 🤝';
      } },
    { id: 'cancellation', topic: 'industry', k: ['cancellation', 'change date', 'covid'],
      chips: ['Payment?', 'Contact us', 'Book now'],
      a: function () {
        return 'Life happens — dates move 📅 Change-of-plans terms get spelled out in your booking agreement so there\'s zero ambiguity. If something\'s shifting, the sooner you text Mariah (' + CALL + ') the more she can do — rebooking to an open date is usually the easy path.<br><br>We\'re a small woman-owned crew, not a faceless corporation. We work with you 💛';
      } },
    { id: 'glassware', topic: 'industry', k: ['glassware', 'real glass', 'plastic', 'eco', 'disposable'],
      chips: ['Whats included', 'Pricing', 'Book now'],
      a: function () {
        return 'Every package ships with quality disposables — cups, flutes for the bubbly, straws, stirrers, bev naps — because nobody wants to run a dish pit at their own party 🥂 Weddings love our <b>personalized custom cups</b> (guests take them home as favors).<br><br>Dreaming of real glassware? Mention it in your ' + link(BOOK, 'booking form') + ' and we\'ll talk options for your headcount.';
      } },
    { id: 'sig-ideas', topic: 'drinks', k: ['signature drink', 'drink ideas', 'what should we serve', 'popular', 'recommend', 'suggestions', 'trendy', 'fall', 'summer', 'winter', 'spring', 'seasonal', 'ideas'],
      chips: ['Drink packages', 'See the menu', 'Book now'],
      a: function () {
        return 'My favorite question 🍸 What\'s hitting right now:<br><br>☀️ <b>Summer:</b> spicy margs, Aperol spritzes, mojitos, vodka lemonades<br>🍂 <b>Fall:</b> apple cider mules, old fashioneds, espresso martinis<br>💍 <b>Weddings:</b> "his & hers" signatures named after the couple — always a hit<br>🎉 <b>Crowd-pleasers:</b> a marg, a mule, something bubbly, something zero-proof<br><br>Mariah designs your menu with you at booking — bring your Pinterest board, she loves that. ' + link(MENU, 'See what\'s pouring') + ' 💛';
      } },
    { id: 'why-mobile', topic: 'industry', k: ['why mobile bar', 'vs caterer', 'worth it', 'diy', 'myself', 'cheaper to'],
      chips: ['Pricing', 'Reviews', 'Book now'],
      a: function () {
        return 'DIY math looks cheap until the day-of 😅 What you\'re actually buying:<br><br>💰 <b>You supply the alcohol at store prices</b> — no caterer markup per drink<br>🍸 Pros pour consistent, safe drinks (and card the teenagers)<br>📋 Exact shopping list = no $300 of leftover mystery liquor<br>🧊 Ice math, mixers, garnish prep, setup, breakdown — handled<br>📸 And the bars are gorgeous. Your cousin\'s folding table is not.<br><br>Hosts tell us the real win is <b>actually attending their own party</b>. ' + link(PRICING, 'The math') + ' is right there 🤝';
      } },
    { id: 'shots', topic: 'industry', k: ['shots', 'over serve', 'drunk', 'cut off', 'safe'],
      chips: ['Kids at events?', 'Book now', 'Contact us'],
      a: function () {
        return 'We keep it fun AND upright 🍻 Our bartenders pace pours, watch the room, and politely tap the brakes when someone\'s ahead of the curve. Water and zero-proof options stay flowing all night.<br><br>Nobody remembers the party where everything went fine. That\'s the point 😌';
      } },

    /* ===== personality ===== */
    { id: 'greet', topic: null, k: ['hi', 'hello', 'hey', 'yo', 'sup', 'morning', 'afternoon', 'evening'],
      chips: ['Pricing', 'Check a date', 'The bars'],
      a: function () { return 'Heyyy 🍸 I\'m Marti — resident martini and unofficial CEO of knowing things. Pricing? Dates? Whether the Mobar fits in your backyard? Hit me.'; } },
    { id: 'joke', topic: null, k: ['joke', 'funny', 'sing', 'dance', 'robot', 'your name', 'marti', 'who are you'],
      chips: ['Ok now pricing', 'The bars', 'Book now'],
      a: function () {
        var bits = [
          'I\'m Marti 🍸 — part martini, part concierge, all personality. I know EVERYTHING about this business and most things about parties. Try me.',
          'Why did the martini get promoted? It delivered under pressure and never lost its olive composure 🫒 ...anyway, want a quote?',
          'Am I real? I\'m a sentient martini with white gloves and opinions about garnish. Define "real" 😌'
        ];
        return bits[Math.floor(Math.random() * bits.length)];
      } },
    { id: 'thanks', topic: null, k: ['thank', 'awesome', 'great', 'perfect', 'love', 'amazing', 'helpful'],
      chips: ['Book now', 'Pricing', 'Bye Marti'],
      a: function () { return 'Olive you too 🫒💛 Anything else, or shall I ' + link(BOOK, 'walk you to the booking form') + '?'; } },
    { id: 'bye', topic: null, k: ['bye', 'goodbye', 'later', 'see ya', 'cya', 'peace'],
      chips: [],
      a: function () { return 'Stay hydrated, bestie 🍋 I\'ll be right here in the corner when the party planning resumes.'; } }
  ];

  /* ---------- date availability lookup ---------- */
  var MONTH_MAP = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, sept: 8, oct: 9, nov: 10, dec: 11 };
  function parseDate(msg) {
    var m = msg.toLowerCase();
    var mo = null, day = null, yr = null;
    var named = m.match(/\b(jan|feb|mar|apr|may|jun|jul|aug|sept?|oct|nov|dec)[a-z]*\s+(\d{1,2})(?:st|nd|rd|th)?(?:[,\s]+(\d{4}))?/);
    if (named) { mo = MONTH_MAP[named[1]]; day = +named[2]; yr = named[3] ? +named[3] : null; }
    else {
      var slash = m.match(/\b(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?\b/);
      if (slash) { mo = +slash[1] - 1; day = +slash[2]; yr = slash[3] ? (+slash[3] < 100 ? 2000 + +slash[3] : +slash[3]) : null; }
    }
    if (mo === null || mo === undefined || !day || mo > 11 || day > 31) return null;
    var now = new Date();
    if (!yr) {
      yr = now.getFullYear();
      if (new Date(yr, mo, day) < now) yr++;
    }
    return new Date(yr, mo, day);
  }

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function checkDate(date, cb) {
    var key = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    var pretty = date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    fetch(BOOK).then(function (r) { return r.text(); }).then(function (html) {
      function attr(name) {
        var m = html.match(new RegExp('data-' + name + '="([^"]*)"'));
        return m ? m[1] : '';
      }
      function grab(bar) {
        return attr('booked-' + bar).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      }
      var all = ['cartini', 'alabaster', 'mobar'];
      var gKey = attr('gcal-key');
      function finish(manual, google) {
        var taken = all.filter(function (b) {
          return manual[b].indexOf(key) !== -1 || (google[b] || []).indexOf(key) !== -1;
        });
        respond(taken);
      }
      var manualSets = {};
      all.forEach(function (b) { manualSets[b] = grab(b); });
      var haveCals = all.some(function (b) { return attr('gcal-' + b); });
      function icsDay(text, wantKey) {
        var u = text.replace(/\r\n[ \t]/g, '').replace(/\n[ \t]/g, '');
        var evs = u.split('BEGIN:VEVENT');
        for (var i = 1; i < evs.length; i++) {
          var ds = evs[i].match(/DTSTART[^:]*:([0-9T]+)/);
          var de = evs[i].match(/DTEND[^:]*:([0-9T]+)/);
          if (!ds) continue;
          var sv = ds[1], ev = de ? de[1] : ds[1];
          function toD(v) { return new Date(+v.slice(0, 4), +v.slice(4, 6) - 1, +v.slice(6, 8)); }
          var d = toD(sv), stop = toD(ev);
          var allDay = ds[0].indexOf('VALUE=DATE') !== -1 || sv.indexOf('T') === -1;
          if (allDay && de) stop = new Date(stop.getTime() - 86400000);
          if (stop < d) stop = d;
          var g = 0;
          while (d <= stop && g++ < 400) {
            var kk = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
            if (kk === wantKey) return true;
            d = new Date(d.getTime() + 86400000);
          }
        }
        return false;
      }
      if (haveCals) {
        var googleSets = {}, pending = 0;
        all.forEach(function (b) {
          var calId = attr('gcal-' + b);
          if (!calId) { googleSets[b] = []; return; }
          pending++;
          var useApi = !!gKey;
          var url;
          if (useApi) {
            var t0 = key + 'T00:00:00Z';
            var t1 = new Date(date.getTime() + 86400000).toISOString();
            url = 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(calId) +
              '/events?key=' + encodeURIComponent(gKey) + '&singleEvents=true&timeMin=' + encodeURIComponent(t0) +
              '&timeMax=' + encodeURIComponent(t1) + '&fields=items(start,end)';
          } else {
            var feed = 'https://calendar.google.com/calendar/ical/' + encodeURIComponent(calId) + '/public/basic.ics';
            url = 'https://api.allorigins.win/raw?url=' + encodeURIComponent(feed);
          }
          fetch(url)
            .then(function (r) { return useApi ? (r.ok ? r.json() : { items: [] }) : r.text(); })
            .then(function (data) { googleSets[b] = (useApi ? (data.items && data.items.length) : icsDay(data, key)) ? [key] : []; })
            .catch(function () { googleSets[b] = []; })
            .then(function () { if (--pending === 0) finish(manualSets, googleSets); });
        });
        if (!pending) finish(manualSets, {});
      } else {
        finish(manualSets, {});
      }
      function respond(taken) {
      if (taken.length === 3) {
        cb('Oof — <b>' + pretty + '</b> shows all three bars booked 😩 BUT bartender-only service might still work, and cancellations happen. Text Mariah: ' + CALL);
      } else if (taken.length) {
        var open = all.filter(function (b) { return taken.indexOf(b) === -1; }).map(cap).join(' & ');
        cb('<b>' + pretty + '</b>: the ' + taken.map(cap).join(' & ') + ' is spoken for, but the <b>' + open + '</b> shows open 🎉 ' + link(BOOK, 'Grab it') + ' before someone else does!');
      } else {
        cb('<b>' + pretty + '</b> is showing <b>open on all three bars</b> as of right now 🎉 Dates aren\'t locked until confirmed though — ' + link(BOOK, 'send the form') + ' and stake your claim!');
      }
      }
    }).catch(function () {
      cb('My calendar connection hiccuped 😅 Check the live one on the ' + link(BOOK, 'booking page') + ' — or text Mariah: ' + CALL);
    });
  }

  /* ---------- answer engine ---------- */
  function answer(msg, cb) {
    var m = msg.toLowerCase();

    // live date check
    if (/\b(free|open|available|book|check)\b/.test(m) || /calendar|date/.test(m)) {
      var d = parseDate(m);
      if (d) { lastTopic = 'book'; return checkDate(d, function (html) { cb(html, ['Pricing', 'The bars', 'How it works']); }); }
    }

    // quote math
    if (/\d{2,3}\s*(guest|people|ppl)/.test(m) && /\d{1,2}\s*(hour|hr)/.test(m)) {
      var g = (m.match(/(\d{2,3})\s*(guest|people|ppl)/) || [])[1];
      var h = (m.match(/(\d{1,2})\s*(hour|hr)/) || [])[1];
      lastTopic = 'price';
      return cb(estimate(+g, +h), ['Drink packages', 'Book now', 'Whats included']);
    }
    if (/do the math|math for me|calculate/.test(m)) {
      lastTopic = 'price';
      return cb('Give me the two magic numbers — like <i>"150 guests for 5 hours"</i> — and I\'ll itemize it right here 🧮', ['120 guests for 4 hours', 'Pricing']);
    }

    var tokens = normalize(msg);
    var best = null, bestScore = 0, second = null, secondScore = 0;
    KB.forEach(function (entry) {
      var score = 0;
      entry.k.forEach(function (kw) {
        if (kw.indexOf(' ') !== -1) {
          if (m.indexOf(kw) !== -1) score += 6;
        } else {
          var kwNorm = SYNONYMS[kw] || kw;
          tokens.forEach(function (t) {
            var tSing = t.length > 3 && t.slice(-1) === 's' ? t.slice(0, -1) : t;
            var kSing = kwNorm.length > 3 && kwNorm.slice(-1) === 's' ? kwNorm.slice(0, -1) : kwNorm;
            if (t === kwNorm || tSing === kSing) score += kwNorm.length > 5 ? 3 : 2;
            else if (fuzzyEq(tSing, kSing)) score += 2;
          });
        }
      });
      if (entry.topic && entry.topic === lastTopic) score *= 1.25;
      if (score > bestScore) { second = best; secondScore = bestScore; best = entry; bestScore = score; }
      else if (score > secondScore) { second = entry; secondScore = score; }
    });

    if (best && bestScore >= 2) {
      lastTopic = best.topic || lastTopic;
      var html = best.a(m);
      return cb(html, best.chips || []);
    }

    cb('Ooh, you might\'ve found the ONE thing I don\'t know 😅 A human won\'t be stumped though:<br><br>' + CALL + ' — call or text Mariah<br><br>Or try me on pricing, dates (<i>"are you free Oct 10?"</i>), drinks, the bars, venue logistics, tipping etiquette... I contain multitudes 🍸',
      ['Pricing', 'Check a date', 'The bars', 'Contact us']);
  }

  /* ---------- UI ---------- */
  var mascotUrl = (window.MARMINI_CHAT && window.MARMINI_CHAT.mascot) || '';
  var root = document.createElement('div');
  root.className = 'marti-chat';
  root.innerHTML =
    '<button class="marti-chat__launcher" type="button" aria-label="Chat with Marti">' +
      '<img src="' + mascotUrl + '" alt="" width="64" height="64"><span class="marti-chat__bubble">Ask Marti 🍸</span>' +
    '</button>' +
    '<div class="marti-chat__panel" hidden>' +
      '<div class="marti-chat__head">' +
        '<img src="' + mascotUrl + '" alt="" width="44" height="44">' +
        '<div><strong>Marti</strong><span>resident martini · knows everything</span></div>' +
        '<button class="marti-chat__close" type="button" aria-label="Close chat">✕</button>' +
      '</div>' +
      '<div class="marti-chat__msgs" aria-live="polite"></div>' +
      '<div class="marti-chat__chips" data-marti-chips></div>' +
      '<form class="marti-chat__form"><input type="text" placeholder="Ask me anything…" aria-label="Message Marti" maxlength="200"><button type="submit" aria-label="Send">➤</button></form>' +
    '</div>';
  document.body.appendChild(root);

  var panel = root.querySelector('.marti-chat__panel');
  var msgs = root.querySelector('.marti-chat__msgs');
  var chipsEl = root.querySelector('[data-marti-chips]');
  var launcher = root.querySelector('.marti-chat__launcher');
  var input = root.querySelector('input');
  var opened = false;

  function push(who, html) {
    var d = document.createElement('div');
    d.className = 'marti-chat__msg marti-chat__msg--' + who;
    d.innerHTML = html;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function setChips(list) {
    chipsEl.innerHTML = '';
    (list || []).slice(0, 4).forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.addEventListener('click', function () { send(label); });
      chipsEl.appendChild(b);
    });
  }

  function botReply(fn) {
    var typing = document.createElement('div');
    typing.className = 'marti-chat__msg marti-chat__msg--bot marti-chat__typing';
    typing.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(typing);
    msgs.scrollTop = msgs.scrollHeight;
    fn(function (html, chips) {
      setTimeout(function () {
        typing.remove();
        push('bot', html);
        setChips(chips);
      }, 450 + Math.min(900, html.length * 2.5));
    });
  }

  function send(text) {
    push('user', text.replace(/</g, '&lt;'));
    botReply(function (done) { answer(text, done); });
  }

  function open() {
    panel.hidden = false;
    launcher.classList.add('is-hidden');
    if (!opened) {
      opened = true;
      botReply(function (done) {
        done('Heyyy, I\'m Marti 🍸 Resident martini, part-time comedian, full-time expert on everything Marmini — and most of the party industry while we\'re at it. Pricing? Dates? Tipping etiquette? Whether the Mobar fits in your backyard? Hit me.',
          ['Pricing', 'Check a date', 'The bars', 'Signature drink ideas']);
      });
    }
    input.focus();
  }
  function close() {
    panel.hidden = true;
    launcher.classList.remove('is-hidden');
  }

  launcher.addEventListener('click', open);
  root.querySelector('.marti-chat__close').addEventListener('click', close);
  root.querySelector('.marti-chat__form').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value.trim();
    if (!v) return;
    input.value = '';
    send(v);
  });

  window.MARTI_TEST = function (q, cb) { answer(q, cb); };
})();
